import { render, staticRenderFns } from "./SelectProductsSection.vue?vue&type=template&id=186d17a1&scoped=true&"
import script from "./SelectProductsSection.vue?vue&type=script&lang=js&"
export * from "./SelectProductsSection.vue?vue&type=script&lang=js&"
import style0 from "./SelectProductsSection.vue?vue&type=style&index=0&id=186d17a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186d17a1",
  null
  
)

export default component.exports